/**
 * The paint a car is drawn with: one colour for the bodywork, then one per overlay slot the livery
 * draws (see CarRenderer on the game server, which reads the same names).
 */

/** What the game paints an overlay with when no colour was chosen (AppearanceLib::WHITE). */
export const WHITE = '#ffffff'

/**
 * The column of a colour, by the index the crest names its zones with: 1 is the bodywork, 2 the first
 * overlay slot, and so on.
 */
export function paintKey(index)
{
  return index === 1 ? 'color' : `color${index}`
}

/** The index of a colour, the other way round: 'color' → 1, 'color3' → 3. */
export function paintIndexOf(key)
{
  return key === 'color' ? 1 : Number(key.replace('color', ''))
}
